import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-snp-error-graph',
  templateUrl: './concordance-graph.component.html',
  styleUrls: ['./concordance-graph.component.css']
})
export class ConcordanceGraphComponent {

  data: any;
  concordance: any;
  checked: boolean = true;
  showSpinner: boolean = true;
  constructor(private dataService: DataService) {
  }

  ngOnInit() {
    this.getConcordances("reference")
  }

  getConcordances(objectName:string){
    this.showSpinner = true;
    this.dataService.getConcordances(objectName).then(data => {
      this.concordance = data;
      this.buildLineChart();
      this.showSpinner = false;
    });
  }

  buildLineChart(){
    this.data = {
      labels: this.concordance.months,
      //datasets: this.strainConcordance.strainConcordances.map((s: { strainName: any; percents: any; }) => ({label: s.strainName, data: s.percents}))
      datasets: this.concordance.concordances.map((s: { objectName: any; percents: any; }) => ({label: s.objectName, data: s.percents}))
    }
  }

  handleChange(e:any) {
    if(this.checked)
    {
      this.getConcordances("reference");
    }
    else
    {
      this.getConcordances("strain");
    }
  }
}
